import { router } from "@inertiajs/react";
import { Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { organizationQuoteItemPath } from "@/routes";
import type { QuoteItem } from "@/types";

interface HasModel<T> {
  model: T;
}
interface WithExtras {
  organizationSlug?: string;
}
const hasModel = <T,>(p: unknown): p is HasModel<T> =>
  typeof p === "object" &&
  p !== null &&
  "model" in (p as Record<string, unknown>);

export const ActionsCell = (props: unknown) => {
  const organizationSlug = (props as WithExtras)?.organizationSlug;

  let item: QuoteItem;
  if (hasModel<QuoteItem>(props)) {
    item = props.model;
  } else {
    item = props as QuoteItem;
  }

  const handleDelete = () => {
    if (!organizationSlug) return;
    if (confirm("¿Está seguro de que desea eliminar este ítem?")) {
      router.delete(organizationQuoteItemPath(organizationSlug, item.id), {
        preserveScroll: true,
      });
    }
  };

  return (
    <div className="flex justify-center items-center h-full">
      <Button
        variant="ghost"
        size="icon"
        onClick={handleDelete}
        className="h-6 w-6 text-red-600"
        disabled={!organizationSlug}
      >
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
};
